(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection_swatch"] && !Shopify.designMode) return;
  try {
    (function() {
    var productCache = {};
    var isPrefetched = false;

    function getBaseUrl() {
      var baseUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      if (baseUrl.charAt(baseUrl.length - 1) === '/') {
        baseUrl = baseUrl.slice(0, -1);
      }
      return baseUrl;
    }

    // NEW: preload product images into browser cache
    function preloadProductImages(productData) {
      if (!productData) return;

      var urls = [];

      if (productData.featured_image) {
        urls.push(productData.featured_image);
      }

      if (Array.isArray(productData.images)) {
        productData.images.forEach(function(src) {
          if (src && urls.indexOf(src) === -1) {
            urls.push(src);
          }
        });
      }

      urls.forEach(function(src) {
        var img = new Image();
        img.src = src;
      });
    }

    // Handles proven to be off the storefront (deleted or unpublished).
    var missingHandles = {};

    // A 404 is logged by the browser's network stack, not by this script, so no
    // .catch() can silence it. What we can do is stop asking twice: remember the
    // dead handles for the tab session, so only the first page view pays the 404
    // and later pages hide the swatch with no request and no flash.
    var DEAD_HANDLES_KEY = 'swatch:missing-handles';

    function loadMissingHandles() {
      try {
        var stored = window.sessionStorage.getItem(DEAD_HANDLES_KEY);
        if (!stored) { return; }
        var list = JSON.parse(stored);
        if (!Array.isArray(list)) { return; }
        list.forEach(function(handle) { missingHandles[handle] = true; });
      } catch (e) {
        // Private mode / storage disabled — fall back to per-page detection.
      }
    }

    function markHandleMissing(handle) {
      missingHandles[handle] = true;
      try {
        window.sessionStorage.setItem(DEAD_HANDLES_KEY, JSON.stringify(Object.keys(missingHandles)));
      } catch (e) {}
    }

    function missingError(handle) {
      var err = new Error('Product no longer on the storefront: ' + handle);
      err.productMissing = true;
      return err;
    }

    function fetchProductByHandle(handle) {
      if (missingHandles[handle]) {
        return Promise.reject(missingError(handle));
      }
      if (productCache[handle]) {
        return Promise.resolve(productCache[handle]);
      }

      var url = getBaseUrl() + '/products/' + encodeURIComponent(handle) + '.js';

      return fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
      .then(function(response) {
        // 404/410 means the product is deleted or unpublished from the Online Store
        // channel. Every other failure is treated as transient, so a flaky connection
        // never wipes out a merchant's swatches.
        if (response.status === 404 || response.status === 410) {
          markHandleMissing(handle);
          throw missingError(handle);
        }
        if (!response.ok) {
          throw new Error('Failed to load product: ' + response.status);
        }
        return response.json();
      })
      .then(function(productData) {
        if (!productData || !productData.id) {
          markHandleMissing(handle);
          throw missingError(handle);
        }
        productCache[handle] = productData;
        // PRELOAD IMAGES HERE
        preloadProductImages(productData);
        return productData;
      });
    }

    // Swatches come from "colour::Name-Value::handle" tags on the sibling products.
    // Those tags survive when a colour is deleted or unpublished, so the dead swatch
    // keeps rendering. Once a handle 404s, take its swatch out of the DOM entirely —
    // hiding it would leave an empty .slick-slide shell behind and strand the stale
    // .slick-track width, which pushes the surviving swatches off-centre.
    function removeSwatchesForHandle(handle) {
      var candidates = document.querySelectorAll('.custom-swatch-tag[data-handle]');
      var doomed = [];

      for (var c = 0; c < candidates.length; c++) {
        var candidate = candidates[c];
        if (candidate.getAttribute('data-handle') !== handle) { continue; }
        // Never drop the card's own product — it is on screen, so it exists.
        if (candidate.classList.contains('active')) { continue; }
        var item = candidate.closest('.swatch-slide-item') || candidate;
        if (doomed.indexOf(item) === -1) { doomed.push(item); }
      }

      if (!doomed.length) { return; }

      var touchedSliders = [];
      doomed.forEach(function(item) {
        var slider = item.closest('.swatch-slick-slider');
        if (slider && touchedSliders.indexOf(slider) === -1) { touchedSliders.push(slider); }
        dropSwatchItem(item, slider);
      });

      touchedSliders.forEach(finaliseSwatchSlider);
    }

    function dropSwatchItem(item, slider) {
      var jq = window.jQuery;

      if (jq && slider && slider.classList.contains('slick-initialized')) {
        // slick wraps each item in .slick-slide > div. slickRemove() takes the slide's
        // CURRENT position (not its data-slick-index, which goes stale after the first
        // removal) and calls reinit(), so the track width is recalculated for us.
        var slide = item.closest('.slick-slide');
        if (slide && slide.parentNode) {
          var index = Array.prototype.indexOf.call(slide.parentNode.children, slide);
          if (index > -1) {
            try {
              jq(slider).slick('slickRemove', index);
              return;
            } catch (e) {
              // Fall through to the plain DOM removal below.
            }
          }
        }
      }

      // Not yet initialised (or slick refused): plain removal. slick will then
      // initialise over the already-clean markup.
      if (item.parentNode) { item.parentNode.removeChild(item); }
    }

    function finaliseSwatchSlider(slider) {
      if (slider.querySelectorAll('.swatch-slide-item').length === 0) {
        // Nothing left to show — drop the wrapper rather than leaving an empty div.
        var root = slider.closest('.custom_swatch_coll') || slider;
        if (root.parentNode) { root.parentNode.removeChild(root); }
        return;
      }

      if (window.jQuery && slider.classList.contains('slick-initialized')) {
        try { window.jQuery(slider).slick('setPosition'); } catch (e) {}
      }
    }

    function prefetchAllSwatchProducts() {
      if (isPrefetched) return;
      isPrefetched = true;

      var swatches = document.querySelectorAll('.custom-swatch-tag[data-handle]');
      var handles = [];

      swatches.forEach(function(swatch) {
        var handle = swatch.getAttribute('data-handle');
        if (handle && handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
      });

      if (!handles.length) return;

      handles.forEach(function(handle) {
        fetchProductByHandle(handle).catch(function(error) {
          if (error && error.productMissing) {
            removeSwatchesForHandle(handle);
          } else {
            console.warn('Failed to prefetch product for handle', handle, error);
          }
        });
      });
    }

    // Ajaxinate appends more cards on infinite scroll, so the sweep has to be
    // repeatable rather than a one-shot on DOMContentLoaded.
    function sweepSwatches() {
      // Synchronous first pass: anything already known dead is hidden before the
      // browser paints, so repeat page views show no flash and fire no request.
      Object.keys(missingHandles).forEach(removeSwatchesForHandle);
      isPrefetched = false;
      prefetchAllSwatchProducts();
    }

    loadMissingHandles();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sweepSwatches);
    } else {
      sweepSwatches();
    }

    // theme.js's _reloadProducts() (tag filtering / sorting) replaces the whole product
    // list with "collectionInnerElement.innerHTML = ..." and then dispatches
    // 'theme:loading:end'. Nothing in the theme ever dispatches 'collection:loaded',
    // so that listener never fired and filtered grids kept their dead swatches.
    document.addEventListener('theme:loading:end', sweepSwatches);
    document.addEventListener('collection:loaded', sweepSwatches);
    window.addEventListener('load', sweepSwatches);

    // Ajaxinate (infinite scroll) and the AJAX filters inject product cards without
    // firing any event this snippet can hook — collection-template.liquid's Ajaxinate
    // callback only calls initSwatchSlickSliders(). So appended cards were never swept,
    // which is why /collections/all still showed dead swatches while a single-page
    // collection like /collections/layla-collection came out clean.
    //
    // Watch for inserted swatches rather than guessing event names. Only addedNodes are
    // inspected and this script only ever removes nodes, so it cannot retrigger itself.
    var sweepQueued = false;

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      window.setTimeout(function() {
        sweepQueued = false;
        sweepSwatches();
      }, 120);
    }

    if (window.MutationObserver) {
      new MutationObserver(function(records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (!node || node.nodeType !== 1) { continue; }
            if (node.classList.contains('custom-swatch-tag') ||
                (node.querySelector && node.querySelector('.custom-swatch-tag'))) {
              queueSweep();
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('click', function(event) {
      var swatch = event.target.closest('.custom-swatch-tag');
      if (!swatch) return;

      var handle = swatch.getAttribute('data-handle');
      if (!handle) return;

      var root = swatch.closest('.custom_swatch_coll');
      if (!root) return;

      var hiddenInput = root.querySelector('.selected-swatch-handle');
      if (hiddenInput) {
        hiddenInput.value = handle;
      }

      var allSwatches = root.querySelectorAll('.custom-swatch-tag');
      allSwatches.forEach(function(item) {
        item.classList.remove('active');
        item.setAttribute('aria-pressed', 'false');
      });

      swatch.classList.add('active');
      swatch.setAttribute('aria-pressed', 'true');

      var changeEvent;
      if (typeof Event === 'function') {
        changeEvent = new Event('swatch:change', { bubbles: true });
      } else {
        changeEvent = document.createEvent('Event');
        changeEvent.initEvent('swatch:change', true, true);
      }
      swatch.dispatchEvent(changeEvent);
    });

    document.addEventListener('swatch:change', function(event) {
      var swatch = event.target;
      var handle = swatch.getAttribute('data-handle');
      if (!handle) return;

      fetchProductByHandle(handle)
        .then(function(productData) {
          updateProductPreviewFromSwatch(swatch, productData);
        })
        .catch(function(error) {
          if (error && error.productMissing) {
            removeSwatchesForHandle(handle);
          } else {
            console.error('Error fetching product data for handle', handle, error);
          }
        });
    });

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function updateCardBadges(card, productData) {
      var holder = card.querySelector('.new-tag-badge, .custom_badge');
      if (!holder) return;
      var tags = productData.tags || [];
      var available = productData.available !== false;
      var html = '';
      if (available) {
        tags.forEach(function (t) {
          if (t.indexOf('new_pro::New') > -1) { html += '<span class="custom-new ">' + esc(t.replace('new_pro::', '')) + '</span>'; }
        });
        tags.forEach(function (t) {
          if (t.indexOf('pro_label::') > -1) { html += '<span class="custom-new ">' + esc(t.replace('pro_label::', '')) + '</span>'; }
        });
        holder.className = ' new-tag-badge';
      } else {
          html = '<span class="custom-soldOut">sold out</span>';
      }
      holder.innerHTML = html;
    }

    function updateProductPreviewFromSwatch(swatch, productData) {
      var root = swatch.closest('.custom_swatch_coll'); if (!root) return;
      var parent_node = root.closest('.ProductItem'); if (!parent_node) return;
      updateCardBadges(parent_node, productData);
      var img = parent_node.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)'); if (!img) return;
      var newSrc = productData && productData.featured_image; if (!newSrc) return;
      img.src = newSrc;
      if (img.hasAttribute('data-src')) { img.setAttribute('data-src', newSrc); }
      if (img.hasAttribute('data-srcset')) { img.setAttribute('data-srcset', newSrc); }
      if (productData.title) { img.alt = productData.title; }
      var altImg = parent_node.querySelector('.ProductItem__Image--alternate');
      if (altImg) {
        var altSrc = (productData.images && productData.images[1]) || newSrc;
        altImg.src = altSrc;
        if (altImg.hasAttribute('data-src')) { altImg.setAttribute('data-src', altSrc); }
        if (altImg.hasAttribute('data-srcset')) { altImg.setAttribute('data-srcset', altSrc); }
      }
      if (productData.url) {
        parent_node.querySelectorAll('a[href*="/products/"]:not(.ProductItem__VariantSwatch)').forEach(function (a) {
          a.setAttribute('href', productData.url);
        });
      }
      var idInput = parent_node.querySelector('form input[name="id"]');
      if (idInput && productData.variants && productData.variants.length) {
        var availableVariant = null;
        for (var vi = 0; vi < productData.variants.length; vi++) {
          if (productData.variants[vi].available) { availableVariant = productData.variants[vi]; break; }
        }
        idInput.value = (availableVariant || productData.variants[0]).id;
      }
      var titleEl = parent_node.querySelector('.ProductItem__Title');
      if (titleEl && productData.title) { titleEl.textContent = productData.title; }
      var price = parent_node.querySelector('.ProductItem__PriceList .ProductItem__Price ');
      if (price && productData.price) { price.innerHTML = `<span class="money">${productData.price / 100}</span>`; }
      var price_min = parent_node.querySelector('.ProductItem__PriceList .Price--highlight .money');
      if (price_min && productData.price) { price_min.innerHTML = `<span class="money">${productData.price / 100}</span>`; }
      var price_compare = parent_node.querySelector('.ProductItem__PriceList .Price--compareAt .money');
      if (price_compare && productData.compare_at_price) { price_compare.innerHTML = `<span class="money">${productData.compare_at_price / 100}</span>`; }
      setTimeout(function() { if (window.DoublyGlobalCurrency && DoublyGlobalCurrency.convertAll) { DoublyGlobalCurrency.convertAll(); } }, 200);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
